import { useState, useEffect } from "react";
import { toDatetimeLocal } from "../../utils/dateUtils";

export default function BottleForm({ onAdd, lastEntry }) {
  const [date, setDate]     = useState(() => toDatetimeLocal());
  const [amount, setAmount] = useState(() => lastEntry?.amount ?? "");
  const [type, setType]     = useState(() => lastEntry?.type   ?? "formula");
  const [notes, setNotes]   = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!amount) return;

    onAdd({
      date:   new Date(date).toISOString(),
      amount,
      type,
      notes: notes || "",
    });

    setDate(toDatetimeLocal());
    setAmount(lastEntry?.amount ?? "");
    setType(lastEntry?.type   ?? "formula");
    setNotes("");
  };

  // When a new entry is added and lastEntry updates, sync the pre-fill values
  // only if the user hasn't already typed something different.
  useEffect(() => {
    if (lastEntry?.amount) {
      setAmount(lastEntry.amount);
      setType(lastEntry.type ?? "formula");
    }
  }, [lastEntry?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const hasPrevious = lastEntry?.amount;

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      {hasPrevious && (
        <p style={{ fontSize: "0.78rem", color: "var(--text-light)", marginBottom: "0.4rem" }}>
          Pre-filled from last feed · {lastEntry.amount} oz · {lastEntry.type === "expressed" ? "Expressed milk" : "Formula"}
          {" "}—{" "}
          <button
            type="button"
            onClick={() => { setAmount(""); setType("formula"); }}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              fontSize: "0.78rem",
              color: "var(--primary-dark)",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            clear
          </button>
        </p>
      )}
      <div className="row g-2">
        <div className="col-md-3">
          <label className="form-label">Date &amp; Time</label>
          <input
            type="datetime-local"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Amount (oz)</label>
          <input
            type="number"
            className="form-control"
            placeholder="e.g. 4"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            step="0.5"
            min="0"
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Type</label>
          <select
            className="form-select"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <option value="formula">Formula</option>
            <option value="expressed">Expressed Milk</option>
          </select>
        </div>
        <div className="col-md-3 d-flex align-items-end">
          <button type="submit" className="btn btn-primary w-100">
            Add Feed
          </button>
        </div>
      </div>
      <div className="row g-2 mt-1">
        <div className="col-12">
          <textarea
            className="form-control form-control-sm"
            placeholder="Add a note..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={2}
            style={{ fontSize: "0.8rem", color: "var(--text-light)", resize: "none" }}
          />
        </div>
      </div>
    </form>
  );
}
